import React, { useState } from 'react';
import ReportFilterBar from '../components/ReportFilterBar';
import ReportTable from '../components/ReportTable';
import ReportDownloadButtons from '../components/ReportDownloadButtons';

const SellTransactionReportPage = () => {
  const [filters, setFilters] = useState({
    asAtDate: new Date().toISOString().split('T')[0],
    portfolio: '',
    isin: '',
    valueDate: '',
    maturityDate: ''
  });

  const filterConfig = [
    { name: 'asAtDate', label: 'As At Date', type: 'date', required: true },
    { name: 'portfolio', label: 'Portfolio', type: 'portfolio' },
    { name: 'isin', label: 'ISIN', type: 'isin' },
    { name: 'valueDate', label: 'Value Date', type: 'date' },
    { name: 'maturityDate', label: 'Maturity Date', type: 'date' }
  ];

  const columns = [
    { key: 'portfolio', label: 'Portfolio' },
    { key: 'custodian', label: 'Custodian' },
    { key: 'deal_number', label: 'Deal Number' },
    { key: 'face_value', label: 'Face Value' },
    { key: 'value_date', label: 'Value Date' },
    { key: 'maturity_date', label: 'Maturity Date' },
    { key: 'isin', label: 'ISIN' },
    { key: 'coupon_interest', label: 'Coupon Interest' },
    { key: 'clean_price', label: 'Clean Price' },
    { key: 'yield', label: 'Yield' },
    { key: 'dtm', label: 'DTM' },
    { key: 'balance', label: 'Balance' },
    { key: 'available_balance', label: 'Available Balance' },
    { key: 'wap', label: 'WAP' },
    { key: 'nvp', label: 'NVP' },
    { key: 'accrued_interest', label: 'Accrued Interest' },
    { key: 'counterparty', label: 'Counterparty' },
    { key: 'buy_deal_number', label: 'Buy Deal Number' },
    { key: 'dirty_price', label: 'Dirty Price' },
    { key: 'settlement_amount', label: 'Settlement Amount' }
  ];

  return (
    <div className="ui-page">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Sell Transaction Report</h2>
      
      <ReportFilterBar
        filters={filters}
        filterConfig={filterConfig}
        onFilterChange={setFilters}
      />
      
      <ReportDownloadButtons
        reportEndpoint="/reports/sell-transaction"
        filters={filters}
        reportName="sell_transaction_report"
      />
      
      <ReportTable
        reportEndpoint="/reports/sell-transaction"
        filters={filters}
        columns={columns}
        emptyMessage="No sell transactions found for the selected criteria."
      />
    </div>
  );
};

export default SellTransactionReportPage;
